import { BackButton, ButtonWrapper, FeedbackSection } from './styled';
import Pill from '@components/Pill';
import {
  Button,
  ChevronLeftSolid,
  Text,
  useTheme,
} from '@simplywallst/ui-core';
import { useTypeformDrawer } from '@/hooks/useTypeformDrawer';

interface Props {
  goBack: () => void;
  isNoteReminderExisting: boolean;
}

export const NoteReminderHeader = ({
  goBack,
  isNoteReminderExisting,
}: Props) => {
  const theme = useTheme();
  const makeTypeformPopup = useTypeformDrawer('nfp2jrdA');

  return (
    <>
      <ButtonWrapper
        gap={`${theme.x1spacePx}px`}
        alignItems="center"
        justifyContent="flex-start"
        templateColumns="auto auto"
      >
        <BackButton styleType="gentleReverse" onClick={goBack}>
          <ChevronLeftSolid />
          &nbsp;
          <Text typography="xSmall" color="chart01">
            {isNoteReminderExisting ? 'Update' : 'Add'} a reminder
          </Text>
        </BackButton>
        <Text as="span" typography="tiny" color="paper">
          <Pill intent="info">Beta</Pill>
        </Text>
      </ButtonWrapper>
      <FeedbackSection
        templateColumns="auto auto"
        gap={`${theme.x1spacePx}px`}
        justifyContentMd="start"
        alignItems="center"
      >
        <Text typography="xSmall" color="whiteRGBA" opacity={0.8}>
          We've recently introduced Reminders.
        </Text>
        <Text typography="xSmall">
          <Button
            marginLeft
            styleType="strongLink"
            display="inline"
            onClick={makeTypeformPopup}
          >
            Give Feedback
          </Button>
        </Text>
      </FeedbackSection>
    </>
  );
};
